import { useAppSelector } from '@redux/store';
import { FC } from 'react';

import DataSourceTypeIcon from '@3.0/DataSourceTypeIcon';
import RDBMSTableIcon from '@3.0/DataSourceTypeIcon/SourceIcons/RDBMSTableIcon';
import { IDataSourceItem } from 'Modules/Studio/DataSources/redux/initialState';
import { TIngestionMode } from './IngestionByDataSource.constants';

const DataSourceListIcon: FC<
  Pick<IDataSourceItem, 'dataSourceType'> & { mode?: TIngestionMode }
> = ({ dataSourceType, mode }) => {
  const view = useAppSelector((state) => state.ingestionDataSourceList.view);

  if (view === 'dataSources' || mode === 'TableViewDataSource')
    return (
      <DataSourceTypeIcon
        dataSourceTypeId={dataSourceType}
        iconProps={{
          width: '16px',
          height: '16px',
          className: 'tw:!text-[16px]',
        }}
      />
    );

  return <RDBMSTableIcon />;
};

export default DataSourceListIcon;
